import variableNames, { variableVariants } from '../constants/variable-names';

const resolveGradientValue = (gradient) => {
  if (!gradient || gradient === 'none') return null;

  return typeof gradient === 'string' ? gradient : null;
};

const resolveBlockBackgroundGradientFromOverrides = (overrides) => {
  if (!overrides || typeof overrides !== 'object') return null;
  const gradientKey = variableVariants[variableNames.BLOCK_BACKGROUND].GRADIENT;

  return resolveGradientValue(overrides[gradientKey]);
};

export default resolveBlockBackgroundGradientFromOverrides;
